"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Tue Aug 07 2018
*/

var typescript_ioc_1 = require("@logio/typescript-ioc");

var StrategyTypeEnum_1 = require("../../model/strategy/StrategyTypeEnum");

var MultiTargetStrategyConverter_1 = require("./MultiTargetStrategyConverter");

var SingleTargetStrategyConverter_1 = require("./SingleTargetStrategyConverter");

var StrategyConverterResolver_1 = require("./StrategyConverterResolver");
/**
 * Default implementation of {@link StrategyConverterResolver}.
 *
 * @author RV
 */


var StrategyConverterResolverImpl =
/*#__PURE__*/
function (_StrategyConverterRes) {
  _inherits(StrategyConverterResolverImpl, _StrategyConverterRes);

  function StrategyConverterResolverImpl(multiTargetStrategyConverter, singleTargetStrategyConverter) {
    var _this;

    _classCallCheck(this, StrategyConverterResolverImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StrategyConverterResolverImpl).call(this));
    _this.multiTargetStrategyConverter = multiTargetStrategyConverter;
    _this.singleTargetStrategyConverter = singleTargetStrategyConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(StrategyConverterResolverImpl, [{
    key: "resolve",
    value: function resolve(type) {
      switch (type) {
        case StrategyTypeEnum_1.StrategyTypeEnum.FollowOneSelected:
        case StrategyTypeEnum_1.StrategyTypeEnum.NotCheaperThan:
        case StrategyTypeEnum_1.StrategyTypeEnum.NotMoreExpensiveThan:
          return this.singleTargetStrategyConverter;

        case StrategyTypeEnum_1.StrategyTypeEnum.FollowMode:
        case StrategyTypeEnum_1.StrategyTypeEnum.FollowCheapest:
        case StrategyTypeEnum_1.StrategyTypeEnum.FollowMostExpensive:
          return this.multiTargetStrategyConverter;

        default:
          {
            throw new Error("Illegal argument exception for given type ".concat(type));
          }
      }
    }
  }]);

  return StrategyConverterResolverImpl;
}(StrategyConverterResolver_1.StrategyConverterResolver);

StrategyConverterResolverImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [MultiTargetStrategyConverter_1.MultiTargetStrategyConverter, SingleTargetStrategyConverter_1.SingleTargetStrategyConverter])], StrategyConverterResolverImpl);
exports.StrategyConverterResolverImpl = StrategyConverterResolverImpl;